import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/login.vue'

const routes = [
  {
    path: '/',
    redirect: '/navhome'
  },
  {
    path: '/login',
    name: 'login',
    // 登录页随入口加载，避免发布后退出登录仍请求已失效的旧 chunk。
    component: Login
  },
  // 首页
  {
    path: '/navhome',
    name: 'navhome',
    component: () => import( '../views/navpage/navhome.vue'),
    redirect: '/navhome/home',
    meta: {
        title: '首页',
        show:true,
        role:[0,2]
    },
    children:[
      {
        path: 'home',
        name: 'home',
        component: () => import( '../views/home.vue'),
        meta: {
            title: '运营驾驶舱',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      }
    ]
  },
  // 拓客引流
  {
    path: '/navtkyl',
    name: 'navtkyl',
    component: () => import( '../views/navpage/navtkyl.vue'),
    redirect: '/navtkyl/qdmanage',
    meta: {
        title: '拓客引流',
        show:true,
        role:[0,2]
    },
    children:[
      {
        path: 'qdmanage',
        name: 'qdmanage',
        component: () => import( '../views/qdmanage.vue'),
        meta: {
            title: '渠道管理',
            img:'qdgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'qdtype',
        name: 'qdtype',
        component: () => import( '../views/qdtype.vue'),
        meta: {
            title: '渠道类别管理',
            img:'qdlbgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'bqmanage',
        name: 'bqmanage',
        component: () => import( '../views/bqmanage.vue'),
        meta: {
            title: '标签管理',
            img:'jdry.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'ewmlist',
        name: 'ewmlist',
        component: () => import( '../views/ewmlist.vue'),
        meta: {
            title: '渠道活码',
            img:'qdhm.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'addhm',
        name: 'addhm',
        component: () => import( '../views/addhm.vue'),
        meta: {
            title: 'addhm',
            img:'',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'hmdata',
        name: 'hmdata',
        component: () => import( '../views/hmdata.vue'),
        meta: {
            title: 'hmdata',
            img:'',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'newaddlinklist',
        name: 'newaddlinklist',
        component: () => import( '../views/newaddlinklist.vue'),
        meta: {
            title: '专属加人码',
            img:'qdhm.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'newaddlink',
        name: 'newaddlink',
        component: () => import( '../views/newaddlink.vue'),
        meta: {
            title: 'newaddlink',
            img:'',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'linkdata',
        name: 'linkdata',
        component: () => import( '../views/linkdata.vue'),
        meta: {
            title: 'linkdata',
            img:'',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'createhm',
        name: 'createhm',
        component: () => import( '../views/createhm.vue'),
        meta: {
            title: 'createhm',
            img:'',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'friendtest',
        name: 'friendtest',
        component: () => import( '../views/friendtest.vue'),
        meta: {
            title: '好友验证语',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'friendwelcome',
        name: 'friendwelcome',
        component: () => import( '../views/friendwelcome.vue'),
        meta: {
            title: '好友欢迎语',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'friendwelcomeadd',
        name: 'friendwelcomeadd',
        component: () => import( '../views/friendwelcomeadd.vue'),
        meta: {
            title: 'friendwelcomeadd',
            img:'navicon.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'phonefriend',
        name: 'phonefriend',
        component: () => import( '../views/phonefriend.vue'),
        meta: {
            title: '手机号加好友',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'phonefriendadd',
        name: 'phonefriendadd',
        component: () => import( '../views/phonefriendadd.vue'),
        meta: {
            title: 'phonefriendadd',
            img:'navicon.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'phonefriendgth',
        name: 'phonefriendgth',
        component: () => import( '../views/phonefriendgth.vue'),
        meta: {
            title: '敢探号外呼任务',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'phonefriendaddgth',
        name: 'phonefriendaddgth',
        component: () => import( '../views/phonefriendaddgth.vue'),
        meta: {
            title: 'phonefriendaddgth',
            img:'navicon.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'infocollectlist',
        name: 'infocollectlist',
        component: () => import( '../views/infocollectlist.vue'),
        meta: {
            title: '信息收集码',
            img:'qdhm.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'infocollectform',
        name: 'infocollectform',
        component: () => import( '../views/infocollectform.vue'),
        meta: {
            title: 'infocollectform',
            img:'',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'phonefrienddetail',
        name: 'phonefrienddetail',
        component: () => import( '../views/phonefrienddetail.vue'),
        meta: {
            title: 'phonefrienddetail',
            img:'navicon.png',
            show:false,
            role:[0,2]
        },
      },
    ]
  },
  // 消息触达
  {
    path: '/navxxcd',
    name: 'navxxcd',
    component: () => import( '../views/navpage/navxxcd.vue'),
    redirect: '/navxxcd/allsendmsg',
    meta: {
        title: '消息触达',
        show:true,
        role:[0,2]
    },
    children:[
      {
        path: 'allsendmsg',
        name: 'allsendmsg',
        component: () => import( '../views/allsendmsg.vue'),
        meta: {
            title: '消息群发',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'allsenddetail',
        name: 'allsenddetail',
        component: () => import( '../views/allsenddetail.vue'),
        meta: {
            title: 'allsenddetail',
            img:'navicon.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'creatallsend',
        name: 'creatallsend',
        component: () => import( '../views/creatallsend.vue'),
        meta: {
            title: 'creatallsend',
            img:'navicon.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'friendCircle',
        name: 'friendCircle',
        component: () => import( '../views/friendCircle.vue'),
        meta: {
            title: '发朋友圈',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'circlelist',
        name: 'circlelist',
        component: () => import( '../views/circlelist.vue'),
        meta: {
            title: '发送记录',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
    ]
  },
  // 营销
  {
    path: '/navyx',
    name: 'navyx',
    component: () => import( '../views/navpage/navyx.vue'),
    redirect: '/navyx/xcxshop',
    meta: {
        title: '营销',
        show:true,
        role:[0,1,2]
    },
    children:[
      {
        path: 'xcxshop',
        name: 'xcxshop',
        component: () => import( '../views/xcxshop.vue'),
        meta: {
            title: '小程序 - 客服报表',
            img:'navicon.png',
            show:true,
            role:[0,1,2]
        },
      },
      {
        path: 'xcxdata',
        name: 'xcxdata',
        component: () => import( '../views/xcxdata.vue'),
        meta: {
            title: '小程序 - 统计报表',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      }
    ]
  },
  // 客户
  {
    path: '/navkh',
    name: 'navkh',
    component: () => import( '../views/navpage/navkh.vue'),
    redirect: '/navkh/khmanage',
    meta: {
        title: '客户',
        show:true,
        role:[0,2]
    },
    children:[
      {
        path: 'khmanage',
        name: 'khmanage',
        component: () => import( '../views/khmanage.vue'),
        meta: {
            title: '客户管理',
            img:'khgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'managedata',
        name: 'managedata',
        component: () => import( '../views/managedata.vue'),
        meta: {
            title: '数据统计',
            img:'khgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'managechange',
        name: 'managechange',
        component: () => import( '../views/managechange.vue'),
        meta: {
            title: '客户转化',
            img:'khgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'circlepeopledata',
        name: 'circlepeopledata',
        component: () => import( '../views/circlepeopledata.vue'),
        meta: {
            title: '客户人群',
            img:'khgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'circlepeopleedit',
        name: 'circlepeopleedit',
        component: () => import( '../views/circlepeopleedit.vue'),
        meta: {
            title: '智能圈选',
            img:'khgl.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'circlepeople',
        name: 'circlepeople',
        component: () => import( '../views/circlepeople.vue'),
        meta: {
            title: '查看人群',
            img:'khgl.png',
            show:false,
            role:[0,2]
        },
      },
      {
        path: 'crowdops',
        name: 'crowdops',
        component: () => import( '../views/crowdops.vue'),
        meta: {
            title: '人群运营',
            img:'khgl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'crowdopstask',
        name: 'crowdopstask',
        component: () => import( '../views/crowdopstask.vue'),
        meta: {
            title: '新建任务',
            img:'khgl.png',
            show:false,
            role:[0,2]
        },
      }
    ]
  },
  // 客服
  {
    path: '/navkf',
    name: 'navkf',
    component: () => import( '../views/navpage/navkf.vue'),
    redirect: '/navkf/accall',
    meta: {
        title: '客服',
        show:true,
        role:[0,1,2]
    },
    children:[
      {
        path: 'accall',
        name: 'accall',
        component: () => import( '../views/accall.vue'),
        meta: {
            title: '客服账号分配',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'phonestate',
        name: 'phonestate',
        component: () => import( '../views/phonestate.vue'),
        meta: {
            title: '手机设备状态',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      // {
      //   path: 'allbmmsg',
      //   name: 'allbmmsg',
      //   component: () => import( '../views/allbmmsg.vue'),
      //   meta: {
      //       title: '部门公共术语',
      //       img:'navicon.png',
      //       show:true
      //   },
      // },
      {
        path: 'acctj',
        name: 'acctj',
        component: () => import( '../views/acctj.vue'),
        meta: {
            title: '客服绩效管理',
            img:'navicon.png',
            show:true,
            role:[0,1,2]
        },
      },
      {
        path: 'talkhistory',
        name: 'talkhistory',
        component: () => import( '../views/talkhistory.vue'),
        meta: {
            title: '客服历史会话',
            img:'navicon.png',
            show:true,
            role:[0,1,2]
        },
      },
      {
        path: 'callonline',
        name: 'callonline',
        component: () => import( '../views/callonline.vue'),
        meta: {
            title: '回复模版',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      // {
      //   path: 'calloutline',
      //   name: 'calloutline',
      //   component: () => import( '../views/calloutline.vue'),
      //   meta: {
      //       title: '无人接待（离线）',
      //       img:'navicon.png',
      //       show:true
      //   },
      // },
      {
        path: 'keyword',
        name: 'keyword',
        component: () => import( '../views/keyword.vue'),
        meta: {
            title: '关联关键词',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'seat',
        name: 'seat',
        component: () => import( '../views/seat.vue'),
        meta: {
            title: '坐席管理',
            img:'navicon.png',
            show:true,
            role:[0,2]
        },
      },
      // {
      //   path: 'agent',
      //   name: 'agent',
      //   component: () => import( '../views/agent.vue'),
      //   meta: {
      //       title: '客服Agent',
      //       img:'navicon.png',
      //       show:true,
      //       role:[0,1]
      //   },
      // },
      // {
      //   path: 'knowledge',
      //   name: 'knowledge',
      //   component: () => import( '../views/knowledge.vue'),
      //   meta: {
      //       title: '知识库',
      //       img:'navicon.png',
      //       show:true,
      //       role:[0,1]
      //   },
      // },
      // {
      //   path: 'autoback',
      //   name: 'autoback',
      //   component: () => import( '../views/navpage/autoback.vue'),
      //   redirect: '/navkf/autoback/keyword',
      //   meta: {
      //       title: '测试',
      //       img:'navicon.png',
      //       show:true
      //   },
      //   children:[
      //     {
      //       path: 'keyword',
      //       name: 'keyword',
      //       component: () => import( '../views/keyword.vue'),
      //       meta: {
      //           title: '关联关键词',
      //           img:'navicon.png',
      //           show:true
      //       },
      //     },
      //   ]
      // },
    ]
  },
  // 我的企业
  {
    path: '/navwdqy',
    name: 'navwdqy',
    component: () => import( '../views/navpage/navwdqy.vue'),
    redirect: '/navwdqy/qwbus',
    meta: {
        title: '我的企业',
        show:true,
        role:[0,2]
    },
    children:[
      {
        path: 'qwbus',
        name: 'qwbus',
        component: () => import( '../views/qwbus.vue'),
        meta: {
            title: '企微主体管理',
            img:'qygl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'qwbusaiwing',
        name: 'qwbusaiwing',
        component: () => import( '../views/qwbusaiwing.vue'),
        meta: {
            title: '企微主体（新版智能体）',
            img:'qygl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'busadmin',
        name: 'busadmin',
        component: () => import( '../views/busadmin.vue'),
        meta: {
            title: '企业管理',
            img:'qygl.png',
            show:true,
            role:[0,2]
        },
      },
      {
        path: 'jdpeople',
        name: 'jdpeople',
        component: () => import( '../views/jdpeople.vue'),
        meta: {
            title: '添加人（坐席）',
            img:'jdry.png',
            show:true,
            role:[0,2]
        },
      }
    ]
  },
  // 我的信息
  {
    path: '/navmine',
    name: 'navmine',
    component: () => import( '../views/navpage/navmine.vue'),
    redirect: '/navmine/mine',
    meta: {
        title: '我的信息',
        show:false,
        role:[0,2]
    },
    children:[
      {
        path: 'mine',
        name: 'mine',
        component: () => import( '../views/mine.vue'),
        meta: {
            title: '我的信息',
            img:'qygl.png',
            show:false,
            role:[0,2]
        },
      },
    ]
  },
  // 信息收集码 H5 填写页（不套后台壳、不做后台鉴权）
  {
    path: '/h5/info-collect',
    name: 'infocollecth5',
    component: () => import( '../views/infocollecth5.vue'),
    meta: {
        title: '信息填写',
        show:false,
        role:[0,2]
    },
  },
]

// 兼容改造前分发的旧 hash 链接：/#/navtkyl/qdmanage?x=1 -> /navtkyl/qdmanage?x=1
// 在 router 初始化前替换地址栏，避免旧链接落到首页。
if (typeof window !== 'undefined' && window.location.hash.indexOf('#/') === 0) {
  window.history.replaceState(null, '', window.location.hash.slice(1))
}

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 发布新版本后，长时间未刷新的旧页面再去加载已删除的 chunk 时，
// 服务器通常会返回 index.html，webpack 就会报 Unexpected token '<' / ChunkLoadError。
// 这里自动刷新一次拿最新入口，避免菜单点击后整页卡死。
const CHUNK_RELOAD_KEY = 'chunk_reload_at'
const isChunkLoadError = (error) => {
  const message = String((error && error.message) || error || '')
  return /Loading chunk .* failed/i.test(message)
    || /ChunkLoadError/i.test(message)
    || /Unexpected token '<'/i.test(message)
    || /Failed to fetch dynamically imported module/i.test(message)
}

router.onError((error) => {
  if (!isChunkLoadError(error)) return
  const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)
  // 10 秒内只刷新一次，避免服务端异常时无限刷新
  if (Date.now() - lastReloadAt < 10000) return
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
  // 带时间戳刷新，绕过可能被缓存的旧 index.html
  const url = new URL(window.location.href)
  url.searchParams.set('_t', Date.now())
  window.location.replace(url.toString())
})

export default router
